function PortalServiceWrapper(
	guideWireService,
	quoteRequestRepository,
	serviceResponseRepository,
	retrieveSavedQuoteResponseTransformer,
	quoteServiceResponseTransformer,
	quoteOptions) {

	function updateQuote(userInput) {
		return quoteRequestRepository.update(userInput);
	}

	function getLastRequest() {
		return quoteRequestRepository.getLastRequest();
	}

	function getLastResponse(serviceName) {
		return serviceResponseRepository.getLastResponseFrom(serviceName);
	}


	function handleSaveQuoteResponse(resp) {
		var data = resp.data;
		if (data.error) {
			console.error(data.error);
			throw data.error;
		}
		serviceResponseRepository.update('quote', data);
		quoteRequestRepository.updateQuoteCredentials(resp);
		return resp;
	}

	function saveQuote(paymentOption, params) {
		var qr = quoteRequestRepository.getSaveQuoteRequest(paymentOption);
		var credentials = quoteRequestRepository.getSelectedQuoteCredentials();
		var qq = guideWireService.saveQuote(qr, credentials, params);
		qq.then(function (resp) {
			return handleSaveQuoteResponse(resp);
		});

		return qq;
	}

	var quickQuoteParams = {
		rating: 'boolean',
		checkUWQuote: 'boolean',
		checkUWBind: 'boolean',
		ruleSet: 'string'
	};

	function getQuoteParams(rules) {
		return {
			rating: rules.price,
			checkUWQuote: rules.quote,
			checkUWBind: rules.purchase,
			ruleSet: rules.ruleSet
		}
	}

	function handleQuickQuoteResponse(resp) {
		var data = resp.data;
		if (data.error) {
			console.error(data.error);
			throw data.error;
		}

		quoteResults = quoteServiceResponseTransformer.transform(data);
		serviceResponseRepository.update('quickQuote', quoteResults);
		quoteOptions.setAvailableQuoteResults(quoteResults);
		updateSelectedCoverTypeIfNoLongerAvailableIn(quoteResults);
		return resp;
	}

	function updateSelectedCoverTypeIfNoLongerAvailableIn(quoteResults) {
		if (!quoteOptions.getSelectedQuoteResult()) {
			console.log('Cover type is no longer available.  Switching to default cover type.');
			quoteOptions.setDefaultCoverType();
			if (!quoteOptions.getSelectedQuoteResult()) {
				throw 'No cover is available';
			}
		}
	}

	//type is 'bike' or 'caravan'
	function checkEmbargo(postcode, type) {
		return guideWireService.checkEmbargo(postcode, type).then(function(resp) {
			return (resp 
				&& resp.data 
				&& resp.data.embargoes 
				&& resp.data.embargoes.length > 0);
		}).catch(function (err) {
			return true;
		});
	}

	function getQuickQuote(permutations, rules, updateSelectedCoverType) {
		var params = getQuoteParams(rules);
		if (updateSelectedCoverType || !permutations.coverTypes) {
			permutations.coverTypes = [quoteOptions.getSelectedCoverType()];
		}
		var multiQuoteRequest = quoteRequestRepository.splitQuotes(permutations);
		var credentials = quoteRequestRepository.getSelectedQuoteCredentials();
		var qq = guideWireService.getQuickQuote(multiQuoteRequest, params, credentials);
		qq.then(function (resp) {
			return handleQuickQuoteResponse(resp);
		}).catch(function (err) {
			return err;
		});

		return qq;
	}

	function triggerGoalSaveQuote() {		
		var credentials = quoteRequestRepository.getSelectedQuoteCredentials();
		if (credentials && credentials.quoteID) {
			var marketingAuto = window.marketingAutomations;
			var maCreateQuote = (marketingAuto && marketingAuto.createQuote) ? marketingAuto.createQuote : undefined;
			var request = quoteRequestRepository.getQuoteTriggerRequest();
			request.QuoteId = credentials.quoteID;
			request.QuoteStatus = "Created";
			request.GoalId = (maCreateQuote) ? maCreateQuote.GoalId : '';
			request.Source = (maCreateQuote) ? maCreateQuote.Source : '';
			request.ChannelId = (maCreateQuote) ? maCreateQuote.ChannelId : '';
			request.EventId = (maCreateQuote) ? maCreateQuote.EventId : '';
			if (request.GoalId && request.EventId) {				
				guideWireService.triggerGoal(request);
			}
		}
	}

	function triggerGoalCompleteQuote() {
		var credentials = quoteRequestRepository.getSelectedQuoteCredentials();
		if (credentials && credentials.quoteID) {
			var marketingAuto = window.marketingAutomations;
			var maCompleteQuote = (marketingAuto && marketingAuto.completeQuote) ? marketingAuto.completeQuote : undefined;
			var request = quoteRequestRepository.getQuoteTriggerRequest();
			request.QuoteId = credentials.quoteID;
			request.QuoteStatus = "Completed";
			request.GoalId = (maCompleteQuote) ? maCompleteQuote.GoalId : '';
			request.Source = (maCompleteQuote) ? maCompleteQuote.Source : '';
			request.ChannelId = (maCompleteQuote) ? maCompleteQuote.ChannelId : '';
			request.EventId = (maCompleteQuote) ? maCompleteQuote.EventId : '';

			if (request.GoalId && request.EventId) {				
				guideWireService.triggerGoal(request);
			}
		}		
	}

	function testQuoteDecline(declineQuoteOptions) {
		if (declineQuoteOptions) {
			var params = getQuoteParams(declineQuoteOptions.rules);
			declineQuoteOptions.permutations.coverTypes = [quoteOptions.getSelectedCoverType()];
			var multiQuoteRequest = quoteRequestRepository.splitQuotes(declineQuoteOptions.permutations);
			var credentials = quoteRequestRepository.getSelectedQuoteCredentials();
			var qq = guideWireService.getQuickQuote(multiQuoteRequest, params, credentials);
			return qq.then(function (resp) {
				return handleDeclineAndReferralResponse(resp);
			});
		}		
	}

	function handleDeclineAndReferralResponse(resp) {
		var data = resp.data;
		if (data.error)
			throw data.error;

		var quote = data[0];
		if (quote.error)
			throw quote.error;

		var declineType = detectDeclineType(quote);
		if (declineType) {
			var declineParams = {
				declineType: declineType,
				declineCodes: []
			};

			quote.quoteResult.uwIssues.forEach(function (element) {
				declineParams.declineCodes.push(element.typeCode);
			}, this);

			throw declineParams;
		}
		return resp;
	}

	function sendDeclineMessagesTOGTM(result) {
		var dataLayer = window.dataLayer = window.dataLayer || [];
		var trackingData = {
			event: 'decline',
			declineCode: []
		}

		result.uwIssues.forEach(function (element) {
			trackingData.declineCode.push(element.typeCode);
		}, this);

		dataLayer.push(trackingData);
	}

	function detectDeclineType(quote) {
		if (quote.quoteResult) {
			if (quote.quoteResult.errors && quote.quoteResult.errors.messages) {
				var message = quote.quoteResult.errors.messages.join('\n') + '\n';
				return 'error';
			} else if (quote.quoteResult.decline && !quote.quoteResult.embargo) {
				sendDeclineMessagesTOGTM(quote.quoteResult);
				return 'decline';
			} else if (quote.quoteResult.referral && !quote.quoteResult.embargo) {
				return 'referral';
			} else if (quote.quoteResult.embargo) {
				return 'embargo';
			}
		}
		return null;
	}

	function retrieveSavedQuote(quoteId, email) {
		var qq = guideWireService.retrieveSavedQuote(quoteId, email)
			.then(function (response) {
				var data = response.data;
				serviceResponseRepository.update('quote', data);
				quoteRequestRepository.updateQuoteCredentials(response);
				return retrieveSavedQuoteResponseTransformer.transform(data);
			});

		return qq;
	}

	function refreshAddress(address) {
		var qq = guideWireService.refreshAddress(address);
		qq.then(function (resp) {
			serviceResponseRepository.update('addressSearch', resp.data);
			return resp.data;
		})
		return qq;
	}

	function refreshVehicleDetails(vgiId, effectiveDate) {
		var qq = guideWireService.refreshVehicleDetails(vgiId, effectiveDate);
		qq.then(function (resp) {
			if (resp.data && resp.data.length > 0) {
				var searchedData = resp.data[0];
				if (!searchedData.goodRetailPrice && searchedData.make) {
					searchedData.goodRetailPrice = "0";
				}
				serviceResponseRepository.update('regoSearch', searchedData);
				return searchedData;
			}
			return null;
		});
		return qq;
	}

	function refreshCaravanDetails(vgiId, effectiveDate) {
		var qq = guideWireService.refreshCaravanDetails(vgiId, effectiveDate);
		qq.then(function (resp) {
			if (resp.data && resp.data.length > 0) {
				serviceResponseRepository.update('regoSearch', resp.data[0]);
				return resp.data;
			}
			return null;
		});
		return qq;
	}

	function doesUserExist(email) {
		return guideWireService.doesUserExist(email);
	}

	return {
		updateQuote: updateQuote,
		getQuickQuote: getQuickQuote,
		saveQuote: saveQuote,
		triggerGoalSaveQuote: triggerGoalSaveQuote,
		triggerGoalCompleteQuote: triggerGoalCompleteQuote,
		testQuoteDecline: testQuoteDecline,
		getLastRequest: getLastRequest,
		getLastResponse: getLastResponse,
		retrieveSavedQuote: retrieveSavedQuote,
		refreshAddress: refreshAddress,
		refreshVehicleDetails: refreshVehicleDetails,
		refreshCaravanDetails: refreshCaravanDetails,
		doesUserExist: doesUserExist,
		checkEmbargo: checkEmbargo
	};
}
